import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components/macro";
import Center from "./Center";
import { Link } from "react-router-dom";

import JunoLogo from "./JunoLogo.js";

/* stylelint-disable no-descending-specificity */

const JunoHeader = styled.header`
  background-color: var(--juno-color-brand);
  color: var(--juno-color-header);
  padding-top: 1em;
  padding-bottom: 1em;
`;

const JunoHeaderInner = styled(Center)`
  display: flex;
  align-items: center;

  a {
    color: var(--juno-color-white);
    border-bottom-style: solid;
    border-bottom-color: transparent;
    display: inline-block;
  }
  a:link {
    color: #f1f2f4;
  }
  a:visited {
    color: #f1f2f4;
  }
  a:hover {
    color: #fff;
    border-bottom-color: #fff;
  }
  a:active {
    color: #fff;
  }
`;

const JunoHeaderLink = styled(Link)`
  margin-left: auto;
  border-bottom-width: 1px;
`;
/* stylelint-enable no-descending-specificity */

class Header extends Component {
  render() {
    return (
      <JunoHeader>
        <JunoHeaderInner pageWidth={this.props.pageWidth}>
          <JunoLogo />
          {this.props.showLogout && <JunoHeaderLink to="/logout">Sign out</JunoHeaderLink>}
        </JunoHeaderInner>
      </JunoHeader>
    );
  }
}

export default Header;

Header.propTypes = {
  pageWidth: PropTypes.string.isRequired,
  showLogout: PropTypes.bool.isRequired,
};
